import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  pill: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.bold,
    borderRadius: designTokens.borderRadius.full,
    padding: "3px 10px",
    whiteSpace: "nowrap" as const,
  },
  pillDone: {
    color: projectIqTokens.green,
    backgroundColor: projectIqTokens.greenBg,
  },
  pillInProgress: {
    color: projectIqTokens.blue,
    backgroundColor: projectIqTokens.blueBg,
  },
  pillNotStarted: {
    color: projectIqTokens.muted,
    backgroundColor: projectIqTokens.bg2,
  },
});
